import {defineStore} from 'pinia';

export const useLoadingStore = defineStore('loading', {
    state: () => {
        return {
            jgLoading: false
        };
    },
    actions: {
        confirm() {
            this.jgLoading = true
        },
        cancel() {
            this.jgLoading = false
        }
    },
    persist: {
        storage: sessionStorage
    }
});
